<waf-boolean-input [(ngModel)]="isSelected" (ngModelChange)="toggleRowSelection()" *ngIf="isVisibleRowSelection" >
</waf-boolean-input>

<waf-boolean-input [ngModel]="search.isAllRowSelected" (ngModelChange)="toggleAllRowSelection($event)" *ngIf="isVisibleRowAllSelection" >
</waf-boolean-input>
